<template>
	<div class="ViewSection">
		<SimpleDTrev/>
	</div>
</template>

<script>
//import DataTable from './DataTable'
//import SimpleDT from './SimpleDT'
import SimpleDTrev from './SimpleDTrev'
//import SimpleYearsDT from './SimpleYearsDT'
//import AngleFixedDT from './AngleFixedDT'
//import HandsontableDT from './HandsontableDT'

export default {
	name: 'ViewSection',
	components: { SimpleDTrev }
}
</script>

<style scoped>
.ViewSection {
	background-color: #eeeeee;
	padding: 0 !important;
	display: inline-block;
	margin: 0;
}
</style>
